"use client";

import { useEffect, useState } from "react";
import type { SearchEngine } from "@coveo/headless";

// Subscribe to the Coveo engine's `search.isLoading` so variants can show a
// spinner while a query is in flight. Properly tears down the subscription on
// unmount (the original components leaked the `unsubscribe` returned from
// `engine.subscribe()` in some places).
export const useSearchResultsLoading = (
  searchEngine: SearchEngine,
): boolean => {
  // Lazy-init from the engine's current state so we don't have to call
  // setState inside the effect just to seed the value (which the lint rule
  // `react-hooks/set-state-in-effect` flags).
  const [isLoading, setIsLoading] = useState(
    () => searchEngine.state.search.isLoading,
  );

  useEffect(() => {
    const unsubscribe = searchEngine.subscribe(() => {
      setIsLoading(searchEngine.state.search.isLoading);
    });
    return () => unsubscribe();
  }, [searchEngine]);

  return isLoading;
};
